import { Component, OnInit, signal } from '@angular/core';
import { fromEvent } from 'rxjs';
import { AbstractCoreComponent } from '@shared/abstracts/abstract-core.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const DESKTOP_MIN_WIDTH = 1024;

@Component({
  selector: 'app-desktop-wrapper',
  standalone: true,
  template: `
    @if (isDesktop()) {
      <ng-content />
    } @else {
      <div class="flex flex-col items-center justify-center h-full gap-4 p-8 text-center">
        <i class="pi pi-desktop text-muted-color" style="font-size: 4rem; opacity: 0.4"></i>
        <p class="text-xl font-semibold text-muted-color m-0" i18n>Questa pagina non è disponibile su dispositivi mobili o tablet.</p>
        <p class="text-muted-color m-0" i18n>Accedi da un browser desktop per continuare.</p>
      </div>
    }
  `,
})
export class DesktopWrapperComponent extends AbstractCoreComponent implements OnInit {
  isDesktop = signal(this.checkDesktop());

  ngOnInit(): void {
    fromEvent(window, 'resize').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.isDesktop.set(this.checkDesktop());
    });
  }

  private checkDesktop(): boolean {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }
}
